import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-[#0A0A0A] text-white">
      <div className="px-4 md:px-8 py-12 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-12 mb-8 md:mb-12">
            <div className="text-center md:text-left">
              <div className="flex items-center gap-3 mb-4 justify-center md:justify-start">
                <img 
                  src="https://public.readdy.ai/ai/img_res/442b38a4-338a-4f74-a271-fc262378c9b4.png" 
                  alt="大石神社" 
                  className="h-10 w-10 md:h-12 md:w-12 object-contain"
                />
                <span className="text-[#D4AF37] font-serif text-lg md:text-xl tracking-wider">大石神社</span>
              </div>
              <p className="text-gray-400 text-sm leading-relaxed">
                京都山科の歴史ある神社<br />
                忠臣蔵ゆかりの聖地
              </p>
            </div>

            <div className="text-center md:text-left">
              <h3 className="text-[#D4AF37] font-semibold mb-4 tracking-wide text-base">神社案内</h3>
              <ul className="space-y-2">
                <li><Link to="/" className="text-gray-400 text-sm hover:text-[#D4AF37] transition-colors cursor-pointer">神社概要</Link></li>
                <li><Link to="/chushingura" className="text-gray-400 text-sm hover:text-[#D4AF37] transition-colors cursor-pointer">忠臣蔵について</Link></li>
                <li><Link to="/festivals" className="text-gray-400 text-sm hover:text-[#D4AF37] transition-colors cursor-pointer">祭礼行事</Link></li>
                <li><Link to="/talismans" className="text-gray-400 text-sm hover:text-[#D4AF37] transition-colors cursor-pointer">授与品一覧</Link></li>
              </ul>
            </div>

            <div className="text-center md:text-left">
              <h3 className="text-[#D4AF37] font-semibold mb-4 tracking-wide text-base">ご参拝</h3>
              <ul className="space-y-2">
                <li><Link to="/prayer-reservation" className="text-gray-400 text-sm hover:text-[#D4AF37] transition-colors cursor-pointer">祈祷予約</Link></li>
                <li><Link to="/access" className="text-gray-400 text-sm hover:text-[#D4AF37] transition-colors cursor-pointer">アクセス</Link></li>
                <li><Link to="/contact" className="text-gray-400 text-sm hover:text-[#D4AF37] transition-colors cursor-pointer">お問い合わせ</Link></li>
              </ul>
            </div>

            <div className="text-center md:text-left">
              <h3 className="text-[#D4AF37] font-semibold mb-4 tracking-wide text-base">お問い合わせ</h3>
              <div className="space-y-3 text-sm text-gray-400">
                <p>〒607-8308<br />京都府京都市山科区<br className="md:hidden" />西野山桜ノ馬場町116</p>
                <p>TEL: 075-581-5645</p>
                <p className="break-all">Email: ooishijinja@gmail.com</p>
              </div>
            </div>
          </div>

          <div className="border-t border-gray-800 pt-6 md:pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-gray-500 text-xs md:text-sm text-center md:text-left">
              © 2025 大石神社 All rights reserved.
            </p>
            <a 
              href="https://readdy.ai/?origin=logo" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-gray-500 text-xs md:text-sm hover:text-[#D4AF37] transition-colors cursor-pointer"
            >
              Website Builder
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
